import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NewsItem = ({ data }) => {
  const navigate = useNavigate();
  const { title, description, image, slug } = data || {};

  const truncateContent = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };

  return (
    <>
      <Paper
        elevation={3}
        onClick={() => navigate(`/post/${slug}`)}
        sx={{
          display: "flex",
          alignItems: "center",
          padding: 1,
          cursor: "pointer",
          width: 400,
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          "&:hover": {
            transform: "scale(1.05)",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        {/* Hình ảnh */}
        <Box
          component="img"
          src={image}
          alt={title}
          sx={{
            width: 150,
            height: 150,
            minWidth: 150,
            maxHeight: 150,
            objectFit: "cover",
            borderRadius: 1,
            marginRight: 2,
            overflow: "hidden",
          }}
        />

        {/* Nội dung */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h7" sx={{ fontWeight: "bold" }}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {truncateContent(description, 100)}{" "}
          </Typography>
        </Box>
      </Paper>
    </>
  );
};

export default NewsItem;
